import React from 'react';
import './PricingComparison.css';

const PricingComparison: React.FC = () => {
  const plans = [
    {
      name: "Zajecia Grupowe",
      price: "65",
      period: "PLN / 60 min",
      description: "Efektywna nauka w malej grupie",
      features: [
        { name: "Grupy 3-6 osob", included: true },
        { name: "Rozne poziomy zaawansowania", included: true },
        { name: "Materialy dydaktyczne", included: true },
        { name: "Wsparcie miedzy zajeciami", included: true },
        { name: "Indywidualny plan nauki", included: false },
        { name: "Elastyczne terminy", included: false }
      ],
      highlighted: false,
      cta: "Wybierz grupowe"
    },
    {
      name: "Zajecia Indywidualne",
      price: "150",
      period: "PLN / 60 min",
      description: "Maksymalna uwaga i personalizacja",
      features: [
        { name: "Zajecia 1:1 z nauczycielem", included: true },
        { name: "Spersonalizowany program", included: true },
        { name: "Materialy dydaktyczne", included: true },
        { name: "Intensywne wsparcie", included: true },
        { name: "Indywidualny plan nauki", included: true },
        { name: "Elastyczne terminy", included: true }
      ],
      highlighted: true,
      cta: "Wybierz indywidualne"
    },
    {
      name: "Program Specjalny",
      price: "Wycena",
      period: "indywidualna",
      description: "Konkursy, olimpiady, specjalna opieka",
      features: [
        { name: "Przygotowanie do olimpiad", included: true },
        { name: "Kursy wakacyjne", included: true },
        { name: "Specjalna opieka pedagogiczna", included: true },
        { name: "Konsultacje rodzinne", included: true },
        { name: "Indywidualny plan nauki", included: true },
        { name: "Pelna elastycznosc", included: true }
      ],
      highlighted: false,
      cta: "Skontaktuj sie"
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="awesome-pricing-section">
      <div className="awesome-pricing-container">
        <div className="awesome-pricing-header">
          <h2 className="awesome-pricing-title">Przejrzysty cennik</h2>
          <p className="awesome-pricing-subtitle">
            Wybierz pakiet dopasowany do Twoich potrzeb. Pierwsza lekcja zawsze gratis.
          </p>
        </div>

        <div className="awesome-pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`awesome-pricing-card ${plan.highlighted ? 'highlighted' : ''}`}
            >
              {plan.highlighted && (
                <span className="awesome-pricing-badge">Najpopularniejszy</span>
              )}

              <div className="awesome-pricing-card-header">
                <h3 className="awesome-plan-name">{plan.name}</h3>
                <div className="awesome-plan-price">
                  <span className="awesome-price-value">{plan.price}</span>
                  <span className="awesome-price-period">{plan.period}</span>
                </div>
                <p className="awesome-plan-description">{plan.description}</p>
              </div>

              <ul className="awesome-plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className={feature.included ? 'included' : 'excluded'}>
                    {feature.included ? (
                      <svg viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    ) : (
                      <svg viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    )}
                    {feature.name}
                  </li>
                ))}
              </ul>

              <button
                className={`awesome-plan-button ${plan.highlighted ? 'highlighted' : ''}`}
                onClick={scrollToContact}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingComparison;
